import { render, staticRenderFns } from "./BasicTextarea.vue?vue&type=template&id=36dac43b"
import script from "./BasicTextarea.vue?vue&type=script&lang=js"
export * from "./BasicTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports